import { Pipe, PipeTransform } from '@angular/core';

/**
 * 教师账号打码管道
 * 长度 <= 7 位不做处理；超过 7 位保留前 3 + 后 4，中间全部替换为 *
 */
@Pipe({
  name: 'maskAccount',
  standalone: true,
})
export class MaskAccountPipe implements PipeTransform {
  transform(value: string | null | undefined): string | null | undefined {
    if (!value) return value;
    if (value.length <= 7) return value;
    return value.slice(0, 3) + '*'.repeat(value.length - 7) + value.slice(-4);
  }
}
